import { Injectable } from '@angular/core';

import { MessageType } from '@cds/push';
import { PlayerStatsCommand } from '@cds/push/fixture-commands';
import { BaseEventModel } from '@frontend/sports/betting-offer/feature/model';
import { ConnectionConfig } from '@frontend/sports/common/client-config-data-access';
import { CdsPushService, CdsSubscription, PlayerStatsSubscription } from '@frontend/sports/content-distribution/feature';
import { BaseSubscriptionService, MessageCallback, MessageHandler } from '@frontend/sports/event-subscription/feature/base-subscription';

@Injectable({ providedIn: 'root' })
export class PlayerStatsSubscriptionService<T extends BaseEventModel> extends BaseSubscriptionService<T> {
    constructor(
        push: CdsPushService,
        protected connection: ConnectionConfig,
    ) {
        super(push);
    }

    protected getContextSubscriptions(event: T, callback: MessageCallback): CdsSubscription[] {
        const playerStatsSubscription = [new PlayerStatsSubscription(event.offerContext, event.id, this.connection.culture, callback)];

        if (event.splitFixtureIds) {
            playerStatsSubscription.push(
                ...event.splitFixtureIds.map((split) => new PlayerStatsSubscription([''], split, this.connection.culture, callback)),
            );
        }

        return playerStatsSubscription;
    }

    protected getHandlers(): Map<MessageType, MessageHandler<T>> {
        const handlers = new Map<MessageType, MessageHandler<T>>();

        handlers.set(MessageType.PlayerStatsUpdate, (evt, cmd) => this.updatePlayerStats(evt, cmd as PlayerStatsCommand));

        return handlers;
    }

    private updatePlayerStats(event: T, command: PlayerStatsCommand): T {
        const receivedStats = command.hybridPlayerStats;
        if (!receivedStats) {
            return event;
        }

        if (!event.playerStats) {
            event.playerStats = [command.hybridPlayerStats];

            return event;
        }

        const filteredStats = event.playerStats.filter((st) => st.source !== receivedStats.source);
        event.playerStats = [...filteredStats, receivedStats];

        return event;
    }
}
